import React from 'react';

import Input from '../../../../UI/Form/Input/Input';
import Button from '../../../../UI/Button/Button';

const CalendarList = () => {

    const clickHandler = event => {
        return;
    };

    return (
        <section className="page-aside-section">
            <h5 className="page-aside-title">CALENDAR LIST</h5>
            <div className="list-group has-actions">
                <div className="list-group-item" data-plugin="editlist">
                    <div className="list-content">
                        <span className="item-right">11</span>
                        <span className="list-text">Meetings Calendar</span>
                    </div>
                    <div className="list-content">
                        <span className="item-right">N/A</span>
                        <span className="list-text">Approvals Calendar</span>
                    </div>
                    <div className="list-content">
                        <span className="item-right">N/A</span>
                        <span className="list-text">Doc Mgmnt Calendar</span>
                    </div>
                    <div className="list-content">
                        <span className="item-right">N/A</span>
                        <span className="list-text">Evaluation Calendar</span>
                    </div>
                    <div className="list-content">
                        <span className="item-right">N/A</span>
                        <span className="list-text">Compliance Calendar</span>
                    </div>
                    <div className="list-editable">
                        <div className="form-group form-material">
                            <Input type="text" className="form-control empty" name="label" value="Admin Calendar" onChange={clickHandler} />
                            <Button buttonType="button" buttonClass="input-editable-close icon md-close" buttonDataToggle="list-editable-close" buttonAriaLabel="Close" buttonAriaExpanded="true"></Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CalendarList;